export const OVERVIEW_CARDS_GRID_GAP = 2

const overviewCardsGridBaseSx = {
  width: "100%",
  display: "grid",
  gap: OVERVIEW_CARDS_GRID_GAP,
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    sm: "repeat(2, minmax(0, 1fr))",
    md: "repeat(3, minmax(0, 1fr))",
  },
}

export const overviewCardsGridSx2 = {
  ...overviewCardsGridBaseSx,
  gridTemplateColumns: {
    ...overviewCardsGridBaseSx.gridTemplateColumns,
    lg: "repeat(2, minmax(0, 1fr))",
  },
}

export const overviewCardsGridSx3 = {
  ...overviewCardsGridBaseSx,
  gridTemplateColumns: {
    ...overviewCardsGridBaseSx.gridTemplateColumns,
    lg: "repeat(3, minmax(0, 1fr))",
  },
}

export const overviewCardsGridSx4 = {
  ...overviewCardsGridBaseSx,
  gridTemplateColumns: {
    ...overviewCardsGridBaseSx.gridTemplateColumns,
    lg: "repeat(4, minmax(0, 1fr))",
  },
}

export const overviewTwoPanelItemGridColumn = {
  xs: "span 1",
  sm: "span 1",
  md: "span 1",
  lg: "span 2",
}

export const OVERVIEW_CHART_FOOTER_MIN_HEIGHT_PX = 40
